<script setup>
import { useDisplayClock } from '@/js/core/composables/useDisplayClock';

const props = defineProps({
  eyebrow: {
    type: String,
    default: 'Harvard GSD',
  },

  title: {
    type: String,
    default: 'Upcoming Events',
  },
});

const { time, timeSlots, date } = useDisplayClock();
</script>

<template>
  <header class="digital-display__header">
    <div class="digital-display__page-info">
      <p class="digital-display__eyebrow">{{ props.eyebrow }}</p>
      <h1 class="digital-display__title">{{ props.title }}</h1>
    </div>

    <div class="digital-display__datetime">
      <p class="digital-display__time" :aria-label="time">
        <span
          v-for="(slot, index) in timeSlots"
          :key="index"
          class="digital-display__time-slot"
          :class="{ 'is-digit': slot.isDigit }"
          aria-hidden="true"
          >{{ slot.char }}</span
        >
      </p>
      <p class="digital-display__date">{{ date }}</p>
    </div>
  </header>
</template>
